require('./command.js');

PegasusTemplate.EditViewOnlineCommand = PegasusTemplate.Command.extend({
  descriptionClass: 'edited',
  description: function(){
    return Em.I18n.t('command_descriptions.edited_web_link');
  }.property(),
  executeSettings: {},
  unexecuteSettings: {},
  execute: function(){
    PegasusTemplate.lookupController('toolbar').setProperties(this.get('executeSettings'));
    this._super();
  },
  unexecute: function(){
    PegasusTemplate.lookupController('toolbar').setProperties(this.get('unexecuteSettings'));
    this._super();
  }
});
